import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useBookingDispatch,
  useBookingState,
} from "../../hooks/useBookingState";
import { BookVal } from "../../utils/bookingUtils";
import { ProdAttrUtils } from "../../utils/productAttributeUtils";

export const ProdAttrOfSimEID: FC<
  ProdAttrPickerModeProps & {
    type: "IMEI" | "EID";
  }
> = ({ type, ...props }) => {
  const state = useBookingState(props);
  const bookingDispatch = useBookingDispatch(props);
  const booka: BookingAttributeDTO | undefined = ProdAttrUtils.findDefaultBooka(
    state.bookingAttributes,
  );
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState<string | null>(null);

  if (booka?.productAttribute?.name !== "SIM") return null;
  const placeHolder =
    type === "IMEI"
      ? `IMEI (15 ${t("characters")})`
      : `EID (32 ${t("characters")})`;
  const size = type === "IMEI" ? 15 : 32;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value ?? "";
    setInputValue(value);

    if (value.length !== 0 && value.length !== size) {
      setError(
        t("Please enter {{size}} characters", {
          size: size + "",
        }) + ".",
      );
    } else {
      setError(null);
    }

    const tmp = BookVal.append(booka)({
      simProductInfo: {
        ...booka.value?.simProductInfo,
        [type.toLowerCase()]: value,
      },
    });
    tmp && bookingDispatch.bookingPick(tmp);
  };

  return (
    <div className="my-5">
      <p className="mb-4 text-sm font-normal text-[#5E6D77] sm:text-base sm:leading-[1.5rem]">
        {t(type)}
      </p>
      <div>
        <div className="box-border flex h-[40px] max-w-[340px] flex-row items-center justify-between rounded-[5px] border border-[#232323] bg-white p-0 px-4">
          <input
            value={inputValue}
            onChange={handleChange}
            type="text"
            placeholder={placeHolder}
            className="my-auto flex h-[22px] w-full items-center border-none text-[16px] font-normal leading-[22px] text-[#232323] outline-none"
            maxLength={size}
          />
        </div>
        {error && (
          <p className="text-sm font-normal not-italic leading-[22px] text-[#DA3838]">
            {error}
          </p>
        )}
      </div>
    </div>
  );
};
